import axios from "axios";
import cloneDeep from "lodash/cloneDeep";
import throttle from "lodash/throttle";
import moment from "moment";
import "rc-pagination/assets/index.css";
import React, { useEffect, useState } from "react";
import { Nav, Tab, Table } from "react-bootstrap";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { useHistory, useParams } from "react-router-dom";
import swal from "sweetalert";
import Banner from "../../../assets/images/BannerAuditionAdmin.png";
import noImage from "../../../assets/images/settings/no-image.png";
import HeaderTitle from "../../Audition_static/Auditon-comp/HeaderTitle";
import JuryGroupCard from "../../Reuseable/JuryGroupCard";
import ReUseableAuditionHeaderTitle from "../../Reuseable/ReUseableAuditionHeaderTitle";
import ReUseableSingleRoundTab from "../../Reuseable/ReUseableSingleRoundTab";
import Button from "../Event/RoundVideoResultFour/Component/Button";
import style2 from "../Event/RoundVideoResultFour/CSS/RoundVideoResult.module.css";
import styles from "../Event/RoundVideoResultOne/CSS/RoundVideoResult.module.css";
import Card from "../Event/RoundVideoResultThree/Component/Card";
import AuditionApproveFilterVideo from "./AuditionApproveFilterVideo";
import AuditionLiveRoundJudgeAssessment from "./AuditionLiveRoundJudgeAssessment";
import AuditionRoundJudgeAssessmentResult from "./AuditionRoundJudgeAssessmentResult";
import "./AuditionRounds.css";
import FinalAssessmentTable from "./FinalAssessmentTable";
import RoundAssessmentResultTable from "./RoundAssessmentResultTable";
import "./TableStyle.css";
import WildcardResultProcess from "./WildcardResultProcess";
import { confirmAlert } from "react-confirm-alert";
import { serverInfo } from "../../../App";
import { useContext } from "react";
import LoaderPost from "../../Reuseable/LoaderPost";
import Back from "../Event/RoundVideoResultFour/Component/Back";

const AuditionRoundAssessmentResult = () => {
  const { imageCdnUrl } = useContext(serverInfo);

  const [videoType, setVideoType] = useState("general");
  const [count, setCount] = useState(1);
  const [filterNumber, setFilterNumber] = useState(1);

  const { slug } = useParams();
  const [loading, setLoading] = useState(true);
  const [isAbleToMerge, setIsAbleToMerge] = useState(false);
  const [activeRound, setActiveRound] = React.useState(0);
  const [step, setStep] = React.useState(1);
  const [singleAssignJury, setSingleAssignJury] = React.useState({});
  const [roundMarkTrackings, setRoundMarkTrackings] = React.useState({});
  const [singleJuryVideos, setSingleJuryVideos] = React.useState([]);
  const [auditionParticipants, setAuditionParticipants] = React.useState([]);
  const [roundBasedVideos, setRoundBasedVideos] = React.useState([]);
  const [isHasNonMarkedVideo, setIsHasNonMarkedVideo] = React.useState(false);
  const [event, setEvent] = useState({});
  const [rounds, setRounds] = useState([]);
  const [juryGroupList, setJuryGroupList] = useState([]);
  const [filterType, setFilterType] = useState("");
  const [auditionRoundInfo, setAuditionRoundInfo] = useState({});
  const [wildcardInfo, setWildcardInfo] = useState([]);
  const [wildcardParticipant, setWildcardParticipant] = useState([]);

  const fetchAuditionDetails = () => {
    axios
      .get(`/api/audition-admin/audition-event/with-rounds/${slug}`)
      .then((res) => {
        if (res.data?.status === 200) {
          setEvent(res.data?.event);
          setActiveRound(res.data?.event.active_round_info_id);
          //if error then add info
          setRounds(res.data?.event?.audition_round);
        }
      });
  };
  const getRoundAndVideos = () => {
    if (event?.id && activeRound && videoType) {
      axios
        .get(
          `/api/audition-admin/audition/singleAuditionRoundAssessmentResult/${event?.id}/${activeRound}/${videoType}`
        )
        .then((res) => {
          if (res.data?.status === 200) {
            setEvent(res.data?.audition);
            setAuditionRoundInfo(res.data?.auditionRoundInfo);
            setJuryGroupList(res.data?.assignJuriesOrderByGroup);
            setAuditionParticipants(res.data?.participants);
            setIsAbleToMerge(res.data?.isAbleToMerge);
            setRoundBasedVideos(res.data?.roundBasedAuditionUploadVideos);
            setWildcardInfo(res.data?.wildcardInfo);
            setLoading(false);
          }
        });
    }
  };

  const handleMergeVideo = () => {
    axios
      .get(
        `/api/audition-admin/audition/singleAuditionRoundVideoMerge/${event?.id}/${activeRound}/${videoType}`
      )
      .then((res) => {
        if (res.data?.status === 200) {
          swal("Success", res.data?.message, "success");
          getRoundAndVideos();
          setStep(3);
        }
      });
  };

  const getWildcardLoveReact = () => {
    axios
      .get(
        `/api/audition-admin/audition-wildcard-mark/wildcardLoveReact/${event?.id}/${wildcardInfo?.start_round_info_id}`
      )
      .then((res) => {
        if (res.data?.status === 200) {
          setWildcardParticipant(res.data?.wildcardParticipant);
        }
      });
  };

  useEffect(() => {
    getWildcardLoveReact();
  }, [wildcardInfo]);

  const handleBackButton = () => {
    setStep(1);
    setSingleAssignJury({});
    setSingleJuryVideos([]);
  };

  const handleAppealedVideos = () => {
    setVideoType("appeal");
    setStep(1);
  };
  const handleWildcardVideos = () => {
    setStep(4);
    setVideoType("wildcard");
  };

  const handleGeneralVideos = () => {
    setStep(1);
    setVideoType("general");
  };

  const handleViewFinalResult = () => {
    setStep(3);
  };
  const handleCountChange = (e) => {
    if (e.target.value > 100 || e.target.value < 0) {
      swal(
        "Opps...",
        "Sorry input field should not more then 100 & short then 0",
        "error"
      );
      setCount(1);
    } else {
      setCount(Number(e.target.value));
    }
  };
  const handleFilterNumberChange = (e) => {
    if (e.target.value < 0) {
      swal("Opps...", "Sorry input field should not short then 0", "error");
      setFilterNumber(1);
    } else {
      setFilterNumber(Number(e.target.value));
    }
  };
  const viewResultByPercentage = () => {
    setFilterType("percentage");
    if (Number(count) > 100 || Number(count) < 0) {
      swal(
        "Opps...",
        "Sorry input field should not more then 100 & short then 0",
        "error"
      );
    } else {
      axios
        .get(
          `/api/audition-admin/audition/singleAuditionRoundVideoResultByPercentage/${event?.id}/${activeRound}/${count}/${videoType}`
        )
        .then((res) => {
          if (res.data?.status === 200) {
            setRoundMarkTrackings(res.data?.percentageBaseRoundMarkTrackings);
            swal(
              "Success",
              "Found " +
                res.data?.percentageBaseRoundMarkTrackings?.length +
                " user for the next round",
              "success"
            );
          }
        });
    }
  };

  const tableHead = [
    "Sl.",
    "Videos",
    "Audience Mark",
    "Mark (Group B)",
    "Mark (Group C)",
    "Mark (Group A)",
  ];

  const viewResultByFilterNumber = () => {
    setFilterType("number");
    if (Number(filterNumber) < 0) {
      swal("Opps...", "Sorry input field should not short then 0", "error");
    } else {
      axios
        .get(
          `/api/audition-admin/audition/singleAuditionRoundVideoResultByFilterNumber/${event?.id}/${activeRound}/${filterNumber}/${videoType}`
        )
        .then((res) => {
          if (res.data?.status === 200) {
            setRoundMarkTrackings(res.data?.filterNumberBaseRoundMarkTrackings);
            swal(
              "Success",
              "Found " +
                res.data?.filterNumberBaseRoundMarkTrackings?.length +
                " user for the next round",
              "success"
            );
          }
        });
    }
  };

  const userSendToManager = () => {
    const fData = new FormData();
    fData.append("percentage_range", count);
    fData.append("filter_number", filterNumber);
    fData.append("filter_type", filterType);
    fData.append("audition_id", event.id);
    fData.append("round_info_id", activeRound);
    fData.append("type", videoType);

    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios
        .post(`/api/audition-admin/audition/roundResultSendToManager`, fData)
        .then((res) => {
          if (res.data?.status == 200) {
            swal("success", res.data?.message, "success");
            setLoading(true);
            getRoundAndVideos();
          }
        });
    });
  };

  function increment() {
    setCount(function (prevCount) {
      if (prevCount < 100) {
        return (prevCount += 1);
      } else {
        return (prevCount = 100);
      }
    });
  }

  function decrement() {
    setCount(function (prevCount) {
      if (prevCount > 0) {
        return (prevCount -= 1);
      } else {
        return (prevCount = 0);
      }
    });
  }
  function incrementNumber() {
    setFilterNumber(function (prevFilterNumber) {
      return (prevFilterNumber += 1);
    });
  }

  function decrementNumber() {
    setFilterNumber(function (prevFilterNumber) {
      if (prevFilterNumber > 0) {
        return (prevFilterNumber -= 1);
      } else {
        return (prevFilterNumber = 0);
      }
    });
  }

  /** For Table */
  const countPerPage = 10;
  const [value, setValue] = React.useState("");
  const [currentPage, setCurrentPage] = React.useState(1);
  const [collection, setCollection] = React.useState(
    cloneDeep(auditionParticipants.slice(0, countPerPage))
  );
  const searchData = React.useRef(
    throttle((val) => {
      const query = val.toLowerCase();
      setCurrentPage(1);
      const data = cloneDeep(
        auditionParticipants
          .filter(
            (item) =>
              item.participant?.last_name.toLowerCase().indexOf(query) > -1
          )
          .slice(0, countPerPage)
      );
      setCollection(data);
    }, 400)
  );

  useEffect(() => {
    if (!value) {
      updatePage(1);
    } else {
      searchData.current(value);
    }
  }, [value]);

  const updatePage = (p) => {
    setCurrentPage(p);
    const to = countPerPage * p;
    const from = to - countPerPage;
    setCollection(cloneDeep(auditionParticipants.slice(from, to)));
  };

  useEffect(() => {
    getRoundAndVideos();
  }, [activeRound]);

  useEffect(() => {
    getRoundAndVideos();
  }, [videoType]);

  useEffect(() => {}, [isHasNonMarkedVideo]);

  useEffect(() => {
    fetchAuditionDetails();
  }, [slug]);

  const tableHead2 = [
    "Name",
    "Email",
    "Audience Mark",
    "Mark (Group B)",
    "Mark (Group c)",
    "Mark (Final)",
  ];

  // Confirm Alert

  function makeConfirm() {
    confirmAlert({
      title: "Please Confirm Carefully",
      message: "If once submit, you cant't undo !",
      buttons: [
        {
          label: "Yes",
          onClick: () => handleMergeVideo(),
        },
        {
          label: "No",
          // onClick: () => alert("Click No"),
        },
      ],
    });
  }

  return (
    <>
      {loading === true ? (
        <LoaderPost />
      ) : (
        <div className="container-lg">
          <div>
            <Tab.Container
              id="left-tabs-example"
              defaultActiveKey={activeRound}
            >
              <div className="container-lg">
                <Nav variant="pills">
                  <div className="row">
                    {rounds &&
                      rounds.map((auditionRound, index) => (
                        <ReUseableSingleRoundTab
                          key={index}
                          auditionRound={auditionRound}
                          setActiveRound={setActiveRound}
                        />
                      ))}
                  </div>
                </Nav>
                <div className="my-4"></div>
              </div>
            </Tab.Container>
          </div>
          {auditionRoundInfo &&
          auditionRoundInfo?.has_jury_or_judge_mark === 0 ? (
            <>
              <div>
                <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                  <Nav
                    variant="pills"
                    className="d-flex justify-content-center"
                  >
                    <div className=" small-live-session mb-3">
                      <Nav.Item>
                        <Nav.Link
                          eventKey="first"
                          className="TabCardGold d-flex  text-decoration-none text-center me-2 fw-bold pt-3 "
                          onClick={handleGeneralVideos}
                        >
                          <h5 className="font-style fw-bold">General Videos</h5>
                        </Nav.Link>
                      </Nav.Item>
                    </div>
                    <div className=" small-live-session mb-3">
                      <Nav.Item>
                        {wildcardInfo && (
                          <Nav.Link
                            eventKey="second"
                            className="TabCardGold d-flex  text-decoration-none text-center me-2 fw-bold pt-3"
                            onClick={handleWildcardVideos}
                          >
                            <h5 className="font-style fw-bold">Wild Card</h5>
                          </Nav.Link>
                        )}
                      </Nav.Item>
                    </div>
                    <div className=" small-live-session">
                      <Nav.Item>
                        <Nav.Link
                          eventKey="third"
                          className="TabCardGold py-2 fw-bold pt-3 text-decoration-none text-center "
                          onClick={handleAppealedVideos}
                        >
                          <h5 className="font-style fw-bold">
                            Appealed Videos
                          </h5>
                        </Nav.Link>
                      </Nav.Item>
                    </div>
                  </Nav>

                  {/* <Tab.Content className="text-light">
                    <Tab.Pane eventKey="first"></Tab.Pane>
                    <Tab.Pane eventKey="second"></Tab.Pane>
                    <Tab.Pane eventKey="third"></Tab.Pane>
                  </Tab.Content> */}
                </Tab.Container>

                <div className="photoRelative">
                  <img
                    style={{ height: "400px" }}
                    src={event?.banner ? imageCdnUrl + event?.banner : Banner}
                    className="img-fluid audioBanner my-3 w-100"
                    alt=""
                  />
                  <h5 className="BannerPs">
                    Round {auditionRoundInfo?.round_num} time duration
                    {moment(auditionRoundInfo?.round_start_date).format("LL")} -
                    {moment(auditionRoundInfo?.round_end_date).format("LL")}
                  </h5>
                </div>

                {step === 1 ? (
                  <>
                    <div className="container-lg">
                      <HeaderTitle
                        title={`Total Videos (${
                          roundBasedVideos && roundBasedVideos.length
                        })`}
                      />

                      <div className="my-3">
                        <AuditionApproveFilterVideo data={roundBasedVideos} />
                      </div>

                      {juryGroupList &&
                        Object.values(juryGroupList).map(
                          (juriesInASingleGroup, parentIndex) => (
                            <div key={parentIndex}>
                              <div className="my-3">
                                <ReUseableAuditionHeaderTitle
                                  isPrimary={
                                    Object.values(juryGroupList)[parentIndex][0]
                                      ?.jury_group?.is_primary
                                  }
                                  title={
                                    event.title +
                                    " - Round " +
                                    auditionRoundInfo?.round_num +
                                    " - Jury Result (Group " +
                                    Object.values(juryGroupList)[parentIndex][0]
                                      ?.jury_group?.name +
                                    ")"
                                  }
                                />
                              </div>
                              <div className="row mb-5">
                                {juriesInASingleGroup.map(
                                  (assignJury, index) => (
                                    <JuryGroupCard
                                      videoType={videoType}
                                      setIsHasNonMarkedVideo={
                                        setIsHasNonMarkedVideo
                                      }
                                      assignJury={assignJury}
                                      key={index}
                                      auditionRoundInfo={auditionRoundInfo}
                                      event={event}
                                      isPrimary={
                                        Object.values(juryGroupList)[
                                          parentIndex
                                        ][0]?.jury_group?.is_primary
                                      }
                                      setStep={setStep}
                                      setSingleAssignJury={setSingleAssignJury}
                                      setSingleJuryVideos={setSingleJuryVideos}
                                    />
                                  )
                                )}
                              </div>
                            </div>
                          )
                        )}
                      <div className="row my-3">
                        <div className="col-md-3 mx-auto">
                          {isHasNonMarkedVideo === false &&
                          isAbleToMerge === true ? (
                            <>
                              <button
                                onClick={makeConfirm}
                                className="btn btnConfirm fw-bold w-100 px-4 py-2"
                              >
                                Merge All the video
                              </button>
                            </>
                          ) : (
                            <>
                              <button
                                onClick={handleViewFinalResult}
                                className="btn btnViewR fw-bold w-100 px-4 py-2"
                              >
                                View Final Result
                              </button>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  <></>
                )}
                {step === 2 ? (
                  <>
                    <div className={styles.details}>
                      <div className={styles.details__header}>
                        <div className={styles.info}>
                          <div>
                            <img
                              src={
                                singleAssignJury?.user?.image != null
                                  ? imageCdnUrl + singleAssignJury?.user?.image
                                  : noImage
                              }
                              alt="profile"
                            />
                          </div>
                          <div>
                            <p>
                              {singleAssignJury?.user?.first_name}
                              {singleAssignJury?.user?.last_name}
                            </p>
                            <span>
                              {singleAssignJury?.user?.category.name} Specialist
                            </span>
                          </div>
                        </div>
                        <div>
                          <p className={styles.details__title}>Details</p>
                        </div>
                      </div>
                      <div>
                        <RoundAssessmentResultTable
                          tableHead={tableHead}
                          data={singleJuryVideos}
                        />
                      </div>
                    </div>

                    <Back onClick={handleBackButton} />
                  </>
                ) : (
                  <></>
                )}

                {step === 3 ? (
                  <>
                    <div className="container-lg">
                      <HeaderTitle
                        title={`Total Videos (${
                          roundBasedVideos && roundBasedVideos.length
                        })`}
                      />

                      <div className="my-3">
                        <AuditionApproveFilterVideo data={roundBasedVideos} />
                      </div>

                      <FinalAssessmentTable
                        tableHead={tableHead2}
                        data={auditionParticipants}
                        auditionRoundInfo={auditionRoundInfo}
                        setAuditionRoundInfo={setAuditionRoundInfo}
                        setVideoType={setVideoType}
                        videoType={videoType}
                      />

                      <div>
                        <ReUseableAuditionHeaderTitle
                          isPrimary={false}
                          title={
                            "Round " +
                            auditionRoundInfo.round_num +
                            " - make result for next round"
                          }
                        />

                        <div className="row mx-1 my-3 card-bg justify-content-center py-4">
                          <div className="col-md-4 card-bg card mb-2 border-0 rounded-0">
                            <div className="card-bg px-3">
                              <b className="text-light">Take</b>
                            </div>
                          </div>
                          <div className="col-md-4 card-bg card mb-2 border-0 rounded-0">
                            <div className="d-flex card-bg px-3 justify-content-around">
                              <button
                                onClick={decrement}
                                className="btn btnDecrement bold"
                              >
                                <i class="fa-solid fa-minus"></i>
                              </button>
                              <input
                                type="number"
                                value={count}
                                onChange={(e) => handleCountChange(e)}
                                onClick={() => setCount("")}
                                className="text-center border-0 from-control bg-black fw-bold btnInput"
                              />
                              <button
                                onClick={increment}
                                className="btn btnIncrement bold"
                              >
                                <i class="fa-solid fa-plus"></i>
                              </button>
                            </div>
                          </div>
                          <div className="col-md-4 card-bg card mb-2 border-0 rounded-0">
                            <div className="card-bg px-3">
                              <b className="text-light">
                                % mark gained user for the next round
                              </b>
                            </div>
                          </div>
                          <Button
                            text={"View Result"}
                            onClick={viewResultByPercentage}
                          />
                        </div>
                      </div>

                      <div>
                        <ReUseableAuditionHeaderTitle
                          isPrimary={false}
                          title={
                            "Round " +
                            auditionRoundInfo.round_num +
                            " - make result for next round"
                          }
                        />

                        <div className="row mx-1 my-3 card-bg justify-content-center py-4">
                          <div className="col-md-4 card-bg card mb-2 border-0 rounded-0">
                            <div className="card-bg px-3">
                              <b className="text-light">Top</b>
                            </div>
                          </div>
                          <div className="col-md-4 card-bg card mb-2 border-0 rounded-0">
                            <div className="d-flex card-bg px-3 justify-content-around">
                              <button
                                onClick={decrementNumber}
                                className="btn btnDecrement bold"
                              >
                                <i class="fa-solid fa-minus"></i>
                              </button>
                              <input
                                type="number"
                                value={filterNumber}
                                onChange={(e) => handleFilterNumberChange(e)}
                                onClick={() => setFilterNumber("")}
                                className="text-center border-0 from-control bg-black fw-bold btnInput"
                              />
                              <button
                                onClick={incrementNumber}
                                className="btn btnIncrement bold"
                              >
                                <i class="fa-solid fa-plus"></i>
                              </button>
                            </div>
                          </div>
                          <div className="col-md-4 card-bg card mb-2 border-0 rounded-0">
                            <div className="card-bg px-3">
                              <b className="text-light">
                                user qualify for the next round
                              </b>
                            </div>
                          </div>
                          <Button
                            text={"View Result"}
                            onClick={viewResultByFilterNumber}
                          />
                        </div>
                      </div>

                      {roundMarkTrackings.length > 0 ? (
                        <div className="row justify-content-center align-items-center mt-5">
                          <Card
                            number={auditionParticipants.length}
                            title={"Total User"}
                            cardText={"User"}
                          />
                          <Card
                            number={roundMarkTrackings.length}
                            title={"Qualify For The Next Round"}
                            cardText={"User"}
                          />
                          <Card
                            number={
                              auditionParticipants.length -
                              roundMarkTrackings.length
                            }
                            title={"Disqualify For This Round"}
                            cardText={"User"}
                          />

                          <div className="row my-3 justify-content-center">
                            {videoType === "general" ? (
                              <>
                                {Number(auditionRoundInfo?.manager_status) !==
                                0 ? (
                                  <Button text={"Already Sent To Manager"} />
                                ) : (
                                  <Button
                                    onClick={userSendToManager}
                                    text={"Approved Request For Manager"}
                                  />
                                )}
                              </>
                            ) : (
                              <>
                                {Number(
                                  auditionRoundInfo?.appeal_manager_status
                                ) !== 0 ? (
                                  <Button
                                    text={"Already Sent To Manager"}
                                    already={0}
                                  />
                                ) : (
                                  <Button
                                    onClick={userSendToManager}
                                    text={"Approved Request For Manager"}
                                  />
                                )}
                              </>
                            )}
                          </div>
                        </div>
                      ) : (
                        <></>
                      )}
                      <Back onClick={handleBackButton} />
                    </div>
                  </>
                ) : (
                  <></>
                )}

                {step === 4 ? (
                  <WildcardResultProcess
                    auditionRoundInfo={auditionRoundInfo}
                    auditionParticipants={auditionParticipants}
                    wildcardParticipant={wildcardParticipant}
                    activeRound={activeRound}
                    eventId={event.id}
                    wildcardInfo={wildcardInfo}
                    getRoundAndVideos={getRoundAndVideos}
                  />
                ) : (
                  <></>
                )}
              </div>
            </>
          ) : (
            <>
              {auditionRoundInfo && auditionRoundInfo?.round_type == 1 ? (
                <AuditionLiveRoundJudgeAssessment
                  tabActiveRound={activeRound}
                />
              ) : (
                <>
                  <AuditionRoundJudgeAssessmentResult
                    tabActiveRound={activeRound}
                  />
                </>
              )}
            </>
          )}
        </div>
      )}
    </>
  );
};

export default AuditionRoundAssessmentResult;
